/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';

import useToast from '../../../hooks/useToast';
import {
  getBusinessUnits,
  getCenters,
  getEvents,
  getImputationTypesService,
  getOperationsOyM,
  typeUbicationSS
} from '../../../services/yclickMaster';
import {
  workPartStatusOptionsForInspector,
  workPartStatusOptionsForAproover
} from '../../../services/serviceRequest';
import { ubicationTypeEnum } from '../../../utils/dataStatus';

const useFilterParams = (isInspector, includeGenericTypes = false, tipoUbicacion = null) => {
  const { setNewToast } = useToast();
  const [ubicationTypeSelect, setUbicationTypeSelect] = useState([]);
  const [events, setEvents] = useState([]);
  const [workPartStatus, setWorkPartStatus] = useState([]);
  const [userBusinessUnits, setUserBusinessUnits] = useState([]);
  const [logisticCenters, setLogisticCenters] = useState([]);
  const [imputationTypes, setImputationTypes] = useState([]);

  const userBusinessUnitsIds = useMemo(
    () => userBusinessUnits.map((e) => e.id),
    [userBusinessUnits]
  );

  const getParams = async () => {
    try {
      const ubicationTypeResult = await typeUbicationSS(includeGenericTypes);

      setUbicationTypeSelect(ubicationTypeResult);

      const eventOptions = await getEvents();

      setEvents(eventOptions);

      const promise = isInspector
        ? workPartStatusOptionsForInspector
        : workPartStatusOptionsForAproover;

      const workPartStatusOpts = await promise();

      setWorkPartStatus(workPartStatusOpts);

      const businessUnitResult = await getBusinessUnits();

      setUserBusinessUnits(businessUnitResult);

      if (isInspector) {
        const centersResults = await getCenters();

        setLogisticCenters(centersResults);

        const imputationTypesResults = await getImputationTypesService();

        setImputationTypes(imputationTypesResults);
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  useEffect(() => {
    if (tipoUbicacion?.id) {
      const isOyM =
        tipoUbicacion?.id !== ubicationTypeEnum.locacion &&
        tipoUbicacion?.id !== ubicationTypeEnum.pozo;

      if (isOyM) {
        getOperationsOyM({
          tipoUbicacionId: tipoUbicacion?.id
        })
          .then(setUserBusinessUnits)
          .catch((err) =>
            setNewToast({
              type: 'ERROR',
              message: err.message
            })
          );
      } else {
        getBusinessUnits()
          .then(setUserBusinessUnits)
          .catch((err) =>
            setNewToast({
              type: 'ERROR',
              message: err.message
            })
          );
      }
    }
  }, [tipoUbicacion?.id]);

  useEffect(() => {
    getParams();
  }, []);

  return {
    ubicationTypeSelect,
    events,
    workPartStatus,
    userBusinessUnits,
    userBusinessUnitsIds,
    logisticCenters,
    imputationTypes
  };
};

export default useFilterParams;
